<template>
  <div class="pages">
    <div class="printArea" ref="printArea">
      <el-descriptions style="text-align: center;margin: 2rem 0;" :title="$t('main.productInquiry')">
        <el-descriptions-item :label="$t('main.InquiryNumber')">{{inquiryInfo.sn}}</el-descriptions-item>
        <el-descriptions-item :label="$t('main.InquiryDate')">{{ handleTimeToString(inquiryInfo.create_time) }}</el-descriptions-item>
        <el-descriptions-item :label="$t('main.totalNum')">{{ inquiryInfo.total_number }}</el-descriptions-item>
      </el-descriptions>
      <el-descriptions v-if="inquiryInfo.address_id" style="text-align: center;margin: 2rem 0;" :title="$t('main.ConsigneeInformation')">
        <el-descriptions-item :label="$t('main.receiver')">{{inquiryInfo.address_info.receive_user}}</el-descriptions-item>
        <el-descriptions-item :label="$t('main.telephone')">{{inquiryInfo.address_info.receive_phone}}</el-descriptions-item>
        <el-descriptions-item :label="$t('main.email')"><a :href="'mailto:' + inquiryInfo.address_info.receive_email">{{inquiryInfo.address_info.receive_email}}</a></el-descriptions-item>
        <el-descriptions-item :label="$t('main.orderCompany')">{{inquiryInfo.address_info.receive_company}}</el-descriptions-item>
        <el-descriptions-item v-if="inquiryInfo.site_id == 1" :label="$t('main.addressDetail')">{{inquiryInfo.address_info.receive_address}}</el-descriptions-item>
        <el-descriptions-item v-if="inquiryInfo.site_id != 1" :label="$t('main.AddressLine1')">{{inquiryInfo.address_info.receive_address}}</el-descriptions-item>
        <el-descriptions-item v-if="inquiryInfo.site_id != 1" :label="$t('main.AddressLine2')">{{inquiryInfo.address_info.receive_address_2}}</el-descriptions-item>
        <el-descriptions-item v-if="inquiryInfo.site_id != 1" :label="$t('main.AddressLine3')">{{inquiryInfo.address_info.receive_address_3}}</el-descriptions-item>
      </el-descriptions>
      <el-table
          :data="tableData"
          border
          style="width: 100%;margin:2rem 0;">
        <el-table-column type="index" :label="$t('main.Item')" width="60"></el-table-column>
        <el-table-column
            header-align="center"
            class="fac"
            prop="product_data"
            :label="$t('main.ProductSpecifications')"
            min-width="500">
          <template slot-scope="scope">
            <div class="fac td-label">
              <img style="cursor: pointer;" @click="gotoProductDetail(scope.row)" :src="scope.row.thumb" class="pImg" />
              <div class="ml20">
                <div class="fac">
                  <div style="width: 12rem">{{ $t('main.product') }}</div>
                  <div style="width: calc(100% - 12rem);cursor: pointer;color: #635796;" @click="gotoProductDetail(scope.row)">{{ scope.row.type_name }}</div>
                </div>
                <div class="fac">
                  <div style="width: 12rem">{{ $t('main.partNumber') }}</div>
                  <div @click="gotoProductDetail(scope.row)" style="width: calc(100% - 12rem);cursor: pointer;color: #635796;">{{ scope.row.product_model }}</div>
                </div>
                <div class="fac color-999" v-for="(hobby, index) in scope.row.product_data" v-if="hobby.isShow" :key="index">
                  <div style="width: 12rem">{{ hobby.title }}</div>
                  <div style="width: calc(100% - 12rem);">{{ hobby.value }}</div>
                </div>
                <div class="fac color-999" v-for="(hobby, index) in scope.row.product_data" v-if="!hobby.isShow && showMore.findIndex(res=>{return res == scope.id;}) > -1" :key="index">
                  <div style="width: 12rem">{{ hobby.title }}</div>
                  <div style="width: calc(100% - 12rem);">{{ hobby.value }}</div>
                </div>
                <div class="fac color-635796" style="cursor: pointer;" @click="handleProductParamsMore(scope)">
                  {{ showMore.findIndex(res=>{return res == scope.id;}) > -1 ? $t('main.Cut') : $t('main.More') }}
                  <i :class="showMore.findIndex(res=>{return res == scope.id;}) > -1 ? 'el-icon-arrow-up':'el-icon-arrow-down'"></i>
                </div>
              </div>
            </div>
          </template>
        </el-table-column>

        <el-table-column
            prop="number"
            align='center'
            min-width="100"
            :label="$t('main.totalNum')">
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import { inquiryRead } from "@/api/inquiry";
import countryList from "@/api/country.json"
import Cookies from "js-cookie";
import {getProductInfo} from "@/api";
export default {
  data() {
    return {
      tableData: [],
      inquiryInfo:{},
      countryList: [],
      tableInfo:[],//表格信息
      showMore: [],
      templates: {
        index: "/",
        single_intro: "/about",
        single_map: "/service/map",
        single_term: "/service/term",
        single_contact: "/contact",
        category_product: "/product",
        category_product_more: "/product/more",
        detail_product:"/product/detail",
        category_join: "/contact",
        category_steps: "/service/steps",
        category_news: "/news",
        category_productDirectory: "/service",
        detail_article: "/news/detail",
      }
    };
  },
  watch: {
    "$store.state.siteInfo":  function(newV, oldV) {
      if (newV && typeof oldV != 'object') {
        this.$router.push({ path: "/userCenter"});
      }
    }
  },
  created(){
    this.getInquiryDetailfun(this.$route.query.id);
    const country = [];
    Object.assign(country, countryList);
    this.countryList = country;
  },
  methods: {
    //到产品界面
    gotoProductDetail(item) {
      let params = {
        req: {
          id: item.type_id
        }
      };
      getProductInfo(params).then(res => {
        if(res.rsp.code === 0) {
          const toItem = res.data;
          let route = this.$router.resolve({
            path: this.getRoutesPath('detail_product', toItem['identification'], toItem['id']),
            query: {
              keyword: item.product_model,
              anchor: "filter"
            }
          });
          window.open(route.href, "_blank");
          window.sessionStorage.setItem("recommend", true);
        } else {
          this.$message({
            message: res.rsp.msg,
            type: "error",
          });
        }
      });
    },
    handleProductParamsMore(item) {
      let isExit = this.showMore.findIndex(res=>{
        return res == item.id;
      });
      if (isExit > -1) {
        this.showMore.splice(isExit, 1);
      } else {
        this.showMore.push(item.id);
      }
    },
    getRoutesPath(template, identification, id) {
      let basePath  = this.templates[template];
      let paramsUrl = '';
      if (identification !== '') {
        paramsUrl = '/'+identification;
      } else if (id !== 'productCenter' && id !== 'index' && id !== '0') {
        paramsUrl = '/'+id;
      } else {
        paramsUrl = '';
      }
      return basePath + paramsUrl;
    },
    getInquiryDetailfun(id){
      const params = {
        "req": {
          "sn": id
        }
      };
      inquiryRead(params).then((res)=>{
        if(res.rsp.code==0){
          this.inquiryInfo = res.data;
          this.tableData = res.data.sn_product_list;
          this.tableInfo = this.tableData.map((item) => {
            item.product_data.map((product)=> {
              item[product.varname] = product.value
            })
          });
        } else {
          this.$message({
            message: res.rsp.msg,
            type: 'error'
          })
        }
      });
    },
    print(){
      // console.log("打印");
      const printArea = this.$refs.printArea;
      const printWindow = window.open('', '_blank');
      printWindow.document.write(printArea.innerHTML);
      printWindow.document.close();
      // 调用打印程序
      printWindow.print();
      printWindow.close();

    },
    handleTimeToString(v) {
      // let date = new Date(parseInt(v) - 1000);
      // let Y = date.getFullYear();
      // let M = date.getMonth() + 1;
      // let D = date.getDate();
      // let H = date.getHours();
      // let m = date.getMinutes();
      // let s = date.getSeconds();
      // return `${Y}-${M}-${D} ${H}:${m}:${s}`;
      var chazhi = Cookies.get("Difference");
      var benditime = v*1000-chazhi;
      let date = new Date(benditime);
      let Y = date.getFullYear();
      let M = date.getMonth() + 1;
      M = M > 9 ? M : "0" + M;
      let D = date.getDate();
      D = D > 9 ? D : "0" + D;
      let H = date.getHours();
      H = H > 9 ? H : "0" + H;
      let m = date.getMinutes();
      m = m > 9 ? m : "0" + m;
      let s = date.getSeconds();
      s = s > 9 ? s : "0" + s;
      return `${Y}-${M}-${D} ${H}:${m}:${s}`;
    }
  }
};
</script>

<style scoped lang="less">
.operatespan{
  padding: 5px 10px;
  margin-left: 5px;
}
.pages {
  min-height: 100%;
  background-color: #fff;
}
.color-999 {
  color: #999999;
}
.ml20 {
  margin-left: 0.5rem;
}
.pImg {
  width: 7.5rem;
}
.td-label {
  text-align: left;
}

.cBtn {
  background-color: #635796;
  border-color: #635796;
  padding: 5px 10px;
  margin-left: 5px;
  color: #FFF;
  display: inline-block;
  line-height: 1;
  white-space: nowrap;
  cursor: pointer;
  -webkit-appearance: none;
  text-align: center;
  box-sizing: border-box;
  outline: 0;
  transition: .1s;
  font-weight: 500;
  font-size: 14px;
  border-radius: 4px;
}
/deep/ .el-descriptions__header{
  text-align: center;

}
/deep/ .el-table .cell{
  text-align: center;
  line-height: unset;
}
/deep/ .el-table .cell p{
  margin: 0;
}
/deep/ .el-button--danger {
  background-color: #635796;
  border-color: #635796;
}
/deep/ .el-input-number {
  display: block;
  margin: 0 auto;
}
/deep/ .el-input-number__decrease,
/deep/ .el-input-number__increase {
  bottom: 1px;
}
@media screen and (max-width: 1400px) {
  .printArea {
    padding: 0 2%;
  }
}
@media screen and (min-width: 1400px) {
  .printArea {
    padding: 0 10%;
  }
}
@media screen and (min-width: 1700px) {
  .printArea {
    padding: 0 15%;
  }
}
</style>
